import './HeaderMenu.scoped.sass'

import { SearchForm } from './SearchForm/SearchForm'
import { UserMenu } from './UserMenu/UserMenu'
import commonsService from '@/services/commons.service'
import store from '@/core/store'
import { Route, Switch } from 'react-router-dom'
import { ReactComponent as BoxesLogoNegative } from '@/assets/svg/boxes-full-white-logo.svg'
import { ReactComponent as BoxesLogoNegativeMobile } from '@/assets/svg/boxes-short-white-logo.svg'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import { useState } from 'react'
export function HeadersMenu () {
  const [credentialsExpired, setCredentialsExpired] = useState(false)
  const showSideMenu = () => {
    store.commit('SIDE_MENU:SHOW')
    store.commit('BOTTOM_MENU:SHOW')
  }

  // sc-160: the blocking SessionExpiredModal now owns re-authentication. This
  // header text is a secondary indicator only — the login link was removed so
  // there is exactly one path back in (the modal), not two that can disagree.
  useRenderEvent(['TOPBAR:USER_CREDENTIALS_EXPIRED'], () => {
    setCredentialsExpired(true)
  })

  return (
    <header className="header-menu">
      { commonsService.isMobile()
        ? (<div className="logo" onClick={() => {
            if (!window.location.href.includes('/settings')) {
              showSideMenu()
            } else {
              commonsService.navigateToInit()
            }
          } }>
          <BoxesLogoNegativeMobile/>
        </div>
          )
        : (<div className="logo" onClick={() => commonsService.navigateToInit()}>
          <BoxesLogoNegative/>
        </div>)
    }
      <div className="right-side">
        {!credentialsExpired
          ? <Switch>
            <Route exact path="/" component={SearchForm} />
            <Route exact path="/history" component={SearchForm} />
            <Route exact path="/boxes" component={SearchForm} />
            <Route path="/settings"/>
            <Route path='/contacts' component={SearchForm}/>
          </Switch>
          : <div className='topbar-session-expired'>Your session has expired</div> }
        <UserMenu />
      </div>
    </header>
  )
}
